module.exports = __webpack_public_path__ + "static/media/video-5.ba7b8d75.jpg";